import { useFlowConfigs } from '@src/hooks/flow/useFlowConfigs';

export const useFlowTimelineMeta = (flowId?: number | string) => {
  const flowConfigs = useFlowConfigs();
  const flowMetadata = flowId ? flowConfigs?.[flowId] : undefined;

  return { isFlowTimeline: !!flowMetadata, flowMetadata } as
    | { isFlowTimeline: false; flowMetadata: undefined }
    | { isFlowTimeline: true; flowMetadata: NonNullable<typeof flowMetadata> };
};
